import React from 'react';

export function getTotalsReports({
  newIsAdmin,
  bonusesResponse,
  variableRevenuesResponse,
  variableRevenuesInsurancesResponse,
  variableRevenuesEnergyResponse,
  variableRevenuesRecurrentEnergyResponse,
  variableRevenuesSignalsResponse,
  variableRevenuesSubAdminsResponse,
  balancePreviousYearsResponse,
}) {
  const { bonusesTotals } = bonusesResponse?.value?.data?.totals || {};
  const { variableRevenues, billableVariableRevenues } =
    variableRevenuesResponse?.value?.data?.totals || {};
  const { variableRevenuesInsurance, billableVariableRevenuesInsurance } =
    variableRevenuesInsurancesResponse?.value?.data?.totals || {};
  const { variableRevenuesEnergy, billableVariableRevenuesEnergy } =
    variableRevenuesEnergyResponse?.value?.data?.totals || {};
  const {
    variableRevenuesRecurrentEnergy,
    billableVariableRevenuesRecurrentEnergy,
  } = variableRevenuesRecurrentEnergyResponse?.value?.data?.totals || {};
  const { variableRevenuesSignals, billableVariableRevenuesSignals } =
    variableRevenuesSignalsResponse?.value?.data?.totals || {};
  const {
    variableRevenuesSubAdmins,
    pastYearsVariableRevenuesSubAdminsTotal,
    pastYearsBillableVariableRevenuesSubAdminsTotal,
    billableVariableRevenuesSubAdmins,
  } = variableRevenuesSubAdminsResponse?.value?.data?.totals || {};

  const {
    previousYearsBonusesTotals,
    pastYearsVariableRevenuesTotal,
    pastYearsBillableVariableRevenuesTotal,
    pastYearsVariableRevenuesInsuranceTotal,
    pastYearsBillableVariableRevenuesInsuranceTotal,
    pastYearsVariableRevenuesSignalsTotal,
    pastYearsBillableVariableRevenuesSignalsTotal,
    pastYearsVariableRevenuesEnergyTotal,
    pastYearsBillableVariableRevenuesEnergyTotal,
    pastYearsVariableRevenuesRecurrentEnergyTotal,
    pastYearsBillableVariableRevenuesRecurrentEnergyTotal,
  } = balancePreviousYearsResponse?.value?.data?.totals || {};

  const totalNet = newIsAdmin
    ? variableRevenuesSubAdmins +
      variableRevenues +
      variableRevenuesEnergy +
      variableRevenuesRecurrentEnergy +
      variableRevenuesSignals +
      variableRevenuesInsurance
    : variableRevenuesSubAdmins +
      variableRevenues +
      variableRevenuesEnergy +
      variableRevenuesRecurrentEnergy +
      variableRevenuesSignals;

  const billableTotalNet = newIsAdmin
    ? billableVariableRevenuesSubAdmins +
      billableVariableRevenues +
      billableVariableRevenuesEnergy +
      billableVariableRevenuesRecurrentEnergy +
      billableVariableRevenuesSignals +
      billableVariableRevenuesInsurance
    : billableVariableRevenuesSubAdmins +
      billableVariableRevenues +
      billableVariableRevenuesEnergy +
      billableVariableRevenuesRecurrentEnergy +
      billableVariableRevenuesSignals;

  const lastYearMasterContractAmount = newIsAdmin
    ? previousYearsBonusesTotals +
      pastYearsVariableRevenuesSubAdminsTotal +
      pastYearsVariableRevenuesTotal +
      pastYearsVariableRevenuesEnergyTotal +
      pastYearsVariableRevenuesRecurrentEnergyTotal +
      pastYearsVariableRevenuesInsuranceTotal +
      pastYearsVariableRevenuesSignalsTotal
    : previousYearsBonusesTotals +
      pastYearsVariableRevenuesSubAdminsTotal +
      pastYearsVariableRevenuesTotal +
      pastYearsVariableRevenuesEnergyTotal +
      pastYearsVariableRevenuesRecurrentEnergyTotal +
      pastYearsVariableRevenuesSignalsTotal;

  const lastYearRevenue = newIsAdmin
    ? previousYearsBonusesTotals +
      pastYearsBillableVariableRevenuesSubAdminsTotal +
      pastYearsBillableVariableRevenuesTotal +
      pastYearsBillableVariableRevenuesEnergyTotal +
      pastYearsBillableVariableRevenuesRecurrentEnergyTotal +
      pastYearsBillableVariableRevenuesInsuranceTotal +
      pastYearsBillableVariableRevenuesSignalsTotal
    : previousYearsBonusesTotals +
      pastYearsBillableVariableRevenuesSubAdminsTotal +
      pastYearsBillableVariableRevenuesTotal +
      pastYearsBillableVariableRevenuesEnergyTotal +
      pastYearsBillableVariableRevenuesRecurrentEnergyTotal +
      pastYearsBillableVariableRevenuesSignalsTotal;

  const total = totalNet + bonusesTotals + lastYearMasterContractAmount;
  const billableTotal = billableTotalNet + bonusesTotals + lastYearRevenue;

  return {
    billableTotal,
    billableTotalNet,
    billableVariableRevenuesSubAdmins,
    billableVariableRevenues,
    billableVariableRevenuesInsurance,
    billableVariableRevenuesEnergy,
    billableVariableRevenuesRecurrentEnergy,
    billableVariableRevenuesSignals,
    bonuses: bonusesTotals,
    total,
    totalNet,
    variableRevenuesSubAdmins,
    variableRevenues,
    variableRevenuesInsurance,
    variableRevenuesEnergy,
    variableRevenuesRecurrentEnergy,
    variableRevenuesSignals,
    lastYearMasterContractAmount,
    lastYearRevenue,
  };
}
